<template>
  <transition name="fade">
    <div>
      <div class="overlay">
        <div :style="styles" :class="{'scrollable': showZonePrice}">
          <span v-if="!showZonePrice" class="close" @click='close'>&times;</span>
          <div v-if="popupType === 'goalsAndDisplayType'  && !showZonePrice">
            <div class="row padding-fix" v-if='goalsAndDisplayCategories'>
              <div v-for='key in Object.keys(goalsAndDisplayCategories).sort()' :class="{'header': true}" :style="{'padding-left': `${calcH()}%`,'width': `${100 / Object.keys(goalsAndDisplayCategories).length}%`}">
                <label>
                  {{ key }}
                </label>
              </div>
            </div>
            <div v-if='!showZonePrice'>
              <dd class="scrollable">
                <div v-for='key in Object.keys(goalsAndDisplayCategories).sort()' :class="{'inline-block': true}" :style="{'padding-top': '1rem', 'padding-left': `${calcH()}%`, 'width': `${100 / Object.keys(goalsAndDisplayCategories).length}%`}">
                  <div v-if = "goalsAndDisplay.type[key] === 'RadioButton'">
                    <div v-if="key === MEGA" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input :id='value.id' :value='value.id' type="radio" v-model='selectedMegaList'/>{{ value.name }}
                    </div>
                    <div v-if="key === DISPLAY" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input :id='value.id' :value='value.id' type="radio" v-model='selectedDisplayList'/>{{ value.name }}
                    </div>
                    <div v-if="key === GOAL" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input :id='value.id' :value='value.id' type="radio" v-model='selectedGoalList'/>{{ value.name }}
                    </div>
                    <div v-if="key === SIGNAGE" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input :id='value.id' :value='value.id' type="radio" v-model='selectedSignatureList'/>{{ value.name }}
                    </div>
                    <div v-if="key === THEME" class="checkbox" v-for='value, i in (goalsAndDisplayCategories[key])'>
                      <input :id='value.id' :value='value.id' type="radio" v-model='selectedThemeList'/>{{ value.name }}
                      <div v-if="i === (goalsAndDisplayCategories[key].length - 1) && selectedThemeList === addTextKeyId">
                        <input type="text" class="hover-detail" :style='styles.editBoxWidthFull' v-model="addTextVmodel">
                      </input>
                      </div>
                    </div>
                    <div v-if="key === DURATION" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input :id='value.id' :value='value.id' type="radio" v-model='selectedDurationList'/>{{ value.name }}
                    </div>
                  </div>
                  <div v-if = "goalsAndDisplay.type[key] === 'Checkbox'">
                    <div v-if="key === MEGA" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input
                      :id='value.id'
                      :value='value.id'
                      :disabled="false"
                      type="checkbox"
                      v-model='selectedMegaList'/>{{ value.name }}
                    </div>
                    <div v-if="key === DISPLAY" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input
                      :id='value.id'
                      :value='value.id'
                      :disabled="false"
                      type="checkbox"
                      v-model='selectedDisplayList'/>{{ value.name }}
                    </div>
                    <div v-if="key === GOAL" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input
                      :id='value.id'
                      :value='value.id'
                      :disabled="false"
                      type="checkbox"
                      v-model='selectedGoalList'/>{{ value.name }}
                    </div>
                    <div v-if="key === SIGNAGE" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input
                      :id='value.id'
                      :value='value.id'
                      :disabled="false"
                      type="checkbox"
                      v-model='selectedSignatureList'/>{{ value.name }}
                    </div>
                    <div v-if="key === THEME" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input
                      :id='value.id'
                      :value='value.id'
                      :disabled="false"
                      type="checkbox"
                      v-model='selectedThemeList'/>{{ value.name }}
                      <!-- <input type="text" class="hover-detail" :style='styles.editBoxWidthFull'> -->
                    </div>
                    <div v-if="key === DURATION" class="checkbox" v-for='value in (goalsAndDisplayCategories[key])'>
                      <input
                      :id='value.id'
                      :value='value.id'
                      :disabled="false"
                      type="checkbox"
                      v-model='selectedDurationList'/>{{ value.name }}
                    </div>
                  </div>
                </div>
              </dd>
              <div class='text-center bottom grid-full'>
                <button
                  :disabled="buttonDisabled"
                  :class="{'width_4': true, 'primary-green-bg': !buttonDisabled}"
                  @click='showTimeZone'>
                  Approve And Lock Offer
                </button>
              </div>
            </div>
          </div>
          <div v-else-if="popupType === 'approveWithChanges' && !showZonePrice" :style='mainContainerStyle.mainStyle.scrollable'>
            <approve-with-changes :handleEvent='approveWithChangesResponse' :confirmEventApproveWithChanges='confirmEventApproveWithChanges'></approve-with-changes>
          </div>
          <div v-else-if="popupType === 'text'">
            <div class='header width_full' style='text-align: center'>
              <label>
                {{ 'Offer Approval Confirmation' }}
              </label>
            </div>
            <div class='field approveMessage'>
              <ul>
                <li v-for="statement in approveMessages()">{{ statement }}.</li>
              </ul>
            </div>
            <div class='text-center bottom grid-full'>
              <button class='primary-green-bg width_5'>Back to pending decisions</button>
            </div>
          </div>
          <div v-else-if="popupType === 'rejectOffer'">
            <div class='header width_full' style='text-align: center'>
              <label>
                {{ 'Type your reason in the following for offer rejection' }}
              </label>
            </div>
            <div class='field'>
              <textarea class="width_full" rows="15" v-model='rejectOfferReason'></textarea>
            </div>
            <div class='text-center bottom grid-full'>
              <button class='primary-green-bg width_4' @click='rejectOffer'>Reject And Lock Offer</button>
            </div>
          </div>
          <div v-else-if='showZonePrice' :style='mainContainerStyle.mainStyle.zoneScrollable'>
            <div :style='mainContainerStyle.mainStyle.tableZonePriceChangeTitleStyle'>
               <label :style='mainContainerStyle.mainStyle.tableZonePriceChangeTitleStyle'>
                 {{ 'Change Zone Sale Retail Prices For This Offer '}}
               </label>
            </div>
            <div :style='mainContainerStyle.mainStyle.tableZonePriceChangeMinHeight' id='selectedOffersInnerDiv'>
              <div class="full_width inline-block" id='zonePriceHeaderContainer'>
                <horizontal-table
                 :handleEvent='horizontalTableEvent'
                 :data='horizontalTableData'
                 :headers='horizontalTableHeaders'
                 :styles='tableStyles.offerZoneListHeaderStyle'/>
               </div>
             </div>
             <div class="width_full" :style='mainContainerStyle.mainStyle.tableButton'>
               <button type="button" @click='updateZoneData' class="primary-green-bg width_4">
                 Set Zone Prices
               </button>
             </div>
           </div>
        </div>
      </div>
      <div v-if="isConfirmPopUp">
        <confirmation-pop-up :data='confirmData'></confirmation-pop-up>
      </div>
    </div>
  </transition>
</template>

<script>
import { values, cloneDeep, merge, find } from 'lodash'
import DataTable from 'src/components/shared/flexTables/DataTable'
import HorizontalTable from 'src/components/shared/flexTables/HorizontalTable'
import { tableStyles } from './tableStyles'
import { mockSelectedOffers } from 'src/components/selected-offers-list/mock'
import { selectedOffersSchema } from 'src/components/selected-offers-list/selectedOffersSchema'
import { mainContainerStyle } from 'src/components/pop-up/mainContainerStyle'
import { mapActions, mapGetters } from 'vuex'
import * as NameSpace from '../../store/NameSpace'
import ConfirmationPopUp from 'src/components/pop-up/ConfirmationPopUp'
import ApproveWithChanges from 'src/components/pop-up/ApproveWithChanges'
import * as CODE from 'src/constants/Constants'

export default {
  data () {
    return {
      tableStyles: tableStyles,
      approveMessage: `The following message has been approved by you.\n This will now be due for Promo Council ratification.\n Promo Description: ${this.approvedData}`,
      approvedData: 'Brand X, Dog Toy, Sizes Small-Large',
      offersListHeaders: null,
      offersListData: null,
      mainContainerStyle: mainContainerStyle,
      scrollableChildrenWidth: '0px',
      scrollableWidth: '0px',
      rejectOfferReason: null,
      showZonePrice: false,
      zoneUpdatedData: [],
      landingScreen: '/pending-offers',
      originalZonePrice: null,
      overrideType: null,
      confirmOverride: null,
      code: null,
      approveWithLockUpdated: null,
      isConfirmPopUp: false,
      changedObjects: {},
      isDefaultChecked: true,
      notInDisplayId: null,
      fixedNotInDisplayId: null,
      displayCheckBoxArray: [],
      selectedMegaList: [],
      selectedDisplayList: [],
      selectedGoalList: [],
      selectedSignatureList: [],
      selectedThemeList: [],
      selectedDurationList: [],
      MEGA: '4-Pager/Mega',
      DISPLAY: 'Display',
      GOAL: 'goal',
      SIGNAGE: 'SIGNAGE TYPE',
      THEME: 'Theme',
      DURATION: 'Duration',
      disabledCheckboxList: [],
      buttonDisabled: false,
      addTextVmodel: '',
      addTextKeyId: '',
      addTextKeyName: '',
      disabledApprovedButton: false,
      headerColumn: 1
    }
  },
  props: ['closePopUp', 'type', 'styles', 'data'],
  watch: {
    // selectedGoalsAndDisplay () {
    //   if (this.selectedGoalsAndDisplay.indexOf(this.fixedNotInDisplayId) !== -1) {
    //     this.notInDisplayId = this.fixedNotInDisplayId
    //     this.displayCheckBoxArray.forEach(i => {
    //       remove(this.selectedGoalsAndDisplay, function (n) {
    //         return n === i
    //       })
    //     })
    //   } else {
    //     this.notInDisplayId = null
    //   }
    // },
    gettersAprroveWithChangesNew () {
      if (this.gettersAprroveWithChangesNew && this.gettersAprroveWithChangesNew.success) {
        if (this.gettersAprroveWithChangesNew.error) {
          this.pop({
            header: 'WARNINGS',
            message: this.gettersAprroveWithChangesNew.error.map(e => {
              let key = Object.keys(e).pop()
              return `${key}: ${e[key]}`
            }),
            buttons: {
              accept: {
                text: 'Ok'
              }
            },
            type: 'SUCCESS'
          })
        }
        this.setZonePrice(this.gettersAprroveWithChangesNew.result)
      } else if (this.gettersAprroveWithChangesNew && this.gettersAprroveWithChangesNew.result && this.gettersAprroveWithChangesNew.result.error) {
        this.styles = mainContainerStyle.mainStyle.approveWithChanges
        this.popupType = 'approveWithChanges'
        let errorMsg
        if (Array.isArray(this.gettersAprroveWithChangesNew.result.error)) {
          errorMsg = this.gettersAprroveWithChangesNew.result.error.map(e => {
            let key = Object.keys(e).pop()
            return `${key}: ${e[key]}`
          })
        } else {
          errorMsg = this.gettersAprroveWithChangesNew.result.error
        }
        this.pop({
          header: 'ERROR',
          message: errorMsg,
          buttons: {
            accept: {
              text: 'Ok'
            }
          },
          type: 'ERROR'
        })
      } else if (this.gettersAprroveWithChangesNew && !this.gettersAprroveWithChangesNew.success) {
        this.pop({
          header: 'Approve Offer',
          message: `Failed In Approve Offer`,
          buttons: {
            accept: {
              text: 'Try again?'
            }
          },
          type: 'ERROR'
        })
      }
    },
    'gettersZoneSalePrice.showAgain' (n, o) {
      // console.log(n, o)
      this.isConfirmPopUp = false
      if (this.gettersZoneSalePrice && this.gettersZoneSalePrice.showAgain) {
        this.showZonePrice = true
      } else if (this.gettersZoneSalePrice.showModal) {
        if (this.gettersZoneSalePrice.error) {
          // this.zoneUpdatedData = []
          this.pop({
            header: 'Approve Offer',
            message: `Failed To Update Zone Prices`,
            buttons: {
              accept: {
                text: 'Try Again'
              }
            },
            type: 'ERROR'
          })
        } else {
          this.zoneUpdatedData = []
          this.$router.push(this.landingScreen)
          this.pop({
            header: 'Approve Offer',
            message: `Successfully Updated Zone Prices`,
            buttons: {
              accept: {
                text: 'Ok'
              }
            },
            type: 'SUCCESS'
          })
        }
      }
    },
    gettersStatusApproveOffer () {
      this.isConfirmPopUp = false
      if (this.gettersStatusApproveOffer && this.gettersStatusApproveOffer.success) {
        this.setZonePrice(this.gettersStatusApproveOffer.result)
      } else if (this.gettersStatusApproveOffer && !this.gettersStatusApproveOffer.success) {
        this.close()
        this.pop({
          header: 'Approve Offer',
          message: `Failed In Approve Offer: ${this.gettersStatusApproveOffer.result}`,
          buttons: {
            accept: {
              text: 'Ok'
            }
          },
          type: 'ERROR'
        })
      }
    },
    gettersRejectOfferResult () {
      if (this.gettersRejectOfferResult && this.gettersRejectOfferResult.rejectOfferResult) {
        this.close()
        this.rejectOfferReason = null
        this.$router.push(this.landingScreen)
        this.pop({
          header: 'Reject Offer',
          message: `Successfully rejected the offer: ${this.gettersRejectOfferResult.rejectOfferResult.offerName}`,
          buttons: {
            accept: {
              text: 'Ok'
            }
          },
          type: 'SUCCESS'
        })
      } else if (this.gettersRejectOfferResult && this.gettersRejectOfferResult.error) {
        this.pop({
          header: 'Approve Offer',
          message: 'Failed in rejecting the offer.',
          buttons: {
            accept: {
              text: 'Ok'
            }
          },
          type: 'ERROR'
        })
      }
    },
    updateZonePriceError () {}
  },
  mounted () {
    this.scrollableWidth = this.getScrollableWidth()
    this.scrollableChildrenWidth = this.getScrollableChildrenWidth()
  },
  computed: {
    ...mapGetters({
      gettersSelectedOfferName: NameSpace.GET_SELECTED_OFFER_NAME,
      gettersStatusApproveOffer: NameSpace.GET_APPROVE_OFFER_SUCCESS,
      gettersRejectOfferResult: NameSpace.GET_REJECT_OFFER_RESULT,
      gettersZoneSalePrice: NameSpace.GET_ZONE_SALE_PRICES,
      gettersAprroveWithChangesNew: NameSpace.GET_APPROVE_WITH_CHANGES_RESULT,
      gettersAprroveWithChanges: NameSpace.GET_APPROVE_WITH_CHANGES
    }),
    // selectedGoalsAndDisplay: {
    //   get () {
    //     return this.goalsAndDisplayArray
    //   },
    //   set (value) {
    //     console.log(value)
    //     if (value === this.fixedNotInDisplayId) {
    //       remove(this.goalsAndDisplayArray, function (n) {
    //         console.log(n)
    //         return n === this.fixedNotInDisplayId
    //       })
    //     } else {
    //       console.log('----------')
    //       // this.goalsAndDisplayArray.push(value)
    //     }
    //     // console.log(this.goalsAndDisplayArray)
    //     // if (this.goalsAndDisplayArray.indexOf(this.fixedNotInDisplayId) === -1) {
    //     //   this.notInDisplayId = null
    //     // } else {
    //     //   // this.selectedGoalsAndDisplay = [this.fixedNotInDisplayId]
    //     //   this.notInDisplayId = this.fixedNotInDisplayId
    //     // }
    //   }
    // },
    itemRemoved () {
      return this.gettersAprroveWithChanges.itemRemoved
    },
    horizontalTableHeaders () {
      return this.gettersZoneSalePrice.headers
    },
    horizontalTableData () {
      if (!this.originalZonePrice) {
        this.originalZonePrice = cloneDeep(this.gettersZoneSalePrice.data)
      }
      return this.gettersZoneSalePrice.data
    },
    updateZonePriceError () {
      if (this.gettersZoneSalePrice.error) {
        let payload = {
          data: cloneDeep(this.originalZonePrice),
          headers: this.horizontalTableHeaders,
          error: null,
          showAgain: true,
          showModal: false
        }
        this.setZonePrice(payload)
        return true
      } else {
        return false
      }
    },
    goalsAndDisplay () {
      // if (this.isDefaultChecked) {
      //   this.setUpGoalsAndDispalyCategories()
      // }
      // this.data.type.Theme = 'RadioButton'
      // console.log(this.data.categories.Theme[2])
      // this.data.categories.Theme[2].default_selection = true
      // this.data.categories.Theme[2].text = 'Hi Yes!'
      // this.addTextVmodel = this.data.categories.Theme[2].text
      // console.log(this.data)
      if (this.isDefaultChecked) {
        this.setUpGoalsAndDispalyCategories()
      }
      return this.data
    },
    goalsAndDisplayCategories () {
      let categories = this.data ? this.data.categories : null
      if (categories) {
        let headerLength
        let arr = []
        if (categories) {
          let cat = categories
          for (let cate in cat) {
            arr.push(cat[cate].length)
          }
          this.headerColumn = arr.length
          headerLength = Math.max(...arr)
        }
        this.styles.height = (10 * headerLength) + '%'
        return this.data.categories
      } else {
        return {}
      }
    },
    confirmData: {
      get () {
        this.confirmOverride
        this.data
        // console.log(this.data)
        // console.log(this.confirmOverride)
        return (this.confirmOverride) ? this.confirmOverride : this.data
      },
      set (val) {
        this.confirmOverride = val
      }
    },
    popupType: {
      get () {
        this.overrideType
        this.type
        return (this.overrideType)
          ? this.overrideType
          : this.type
      },
      set (val) {
        this.overrideType = val
      }
    }
  },
  methods: {
    ...mapActions({
      actionApproveOffers: NameSpace.ACTION_APPROVE_OFFER,
      actionRejectOffer: NameSpace.ACTION_REJECT_OFFER,
      actionGetGoalsAndDisplay: NameSpace.ACTION_GOALS_AND_DISPLAY,
      pop: NameSpace.SET_MODAL_CONFIG_ACTION,
      setZonePrice: NameSpace.SET_ZONE_STATE,
      updateZonePrice: NameSpace.UPDATE_ZONE_STATE,
      submitOfferLock: NameSpace.SUBMIT_OFFER_LOCK
    }),
    calcH () {
      if (this.headerColumn === 2) {
        return 20
      } else if (this.headerColumn === 3) {
        return 10
      } else if (this.headerColumn === 4) {
        return 2
      } else {
        return 0
      }
    },
    // maintainItems (id) {
    //   console.log(id, this.selectedGoalsAndDisplay, this.selectedGoalsAndDisplay.indexOf(this.fixedNotInDisplayId))
    //   if (id === this.fixedNotInDisplayId && this.selectedGoalsAndDisplay.indexOf(this.fixedNotInDisplayId) !== -1) {
    //     this.notInDisplayId = this.fixedNotInDisplayId
    //     this.displayCheckBoxArray.forEach(i => {
    //       console.log('i', i)
    //       remove(this.selectedGoalsAndDisplay, function (n) {
    //         console.log('n', n)
    //         return n === i
    //       })
    //       console.log('remove-----', this.selectedGoalsAndDisplay)
    //     })
    //   } else {
    //     console.log('null-----')
    //     this.notInDisplayId = null
    //   }
    //   // console.log(this.selectedGoalsAndDisplay)
    // },
    setUpGoalsAndDispalyCategories () {
      if (typeof this.data === 'object') {
        const { categories, type } = this.data
        let mainKeys = Object.keys(categories)
        mainKeys.forEach(key => {
          let array = categories[key]
          for (let k = 0; k < array.length; k++) {
            let object = array[k]
            if (type[key] === 'Checkbox') {
              if (object.default_selection) {
                if (key === this.MEGA) {
                  this.selectedMegaList.push(object.id)
                }
                if (key === this.GOAL) {
                  this.selectedGoalList.push(object.id)
                }
                if (key === this.DISPLAY) {
                  this.selectedDisplayList.push(object.id)
                }
                if (key === this.SIGNAGE) {
                  this.selectedSignatureList.push(object.id)
                }
                if (key === this.DURATION) {
                  this.selectedDurationList.push(object.id)
                }
              }
            }
            if (type[key] === 'RadioButton') {
              if (object.default_selection) {
                if (key === this.MEGA) {
                  this.selectedMegaList = object.id
                }
                if (key === this.GOAL) {
                  this.selectedGoalList = object.id
                }
                if (key === this.DISPLAY) {
                  this.selectedDisplayList = object.id
                }
                if (key === this.SIGNAGE) {
                  this.selectedSignatureList = object.id
                }
                if (key === this.DURATION) {
                  this.selectedDurationList = object.id
                }
                if (key === this.THEME) {
                  if (object.name.toLowerCase() === 'others') {
                    this.addTextKeyId = object.id
                    this.addTextKeyName = object.name
                    this.addTextVmodel = object.text
                  }
                  this.selectedThemeList = object.id
                }
              } else {
                if (key === this.THEME) {
                  if (object.name.toLowerCase() === 'others') {
                    console.log('HDUVJBFDF')
                    this.addTextKeyId = object.id
                    this.addTextKeyName = object.name
                    this.addTextVmodel = object.text
                  }
                }
              }
            }

            // if (key === 'Display') {
            //   if (object.name !== 'Not In Display') {
            //     this.displayCheckBoxArray.push(object.id)
            //   }
            // }
            // if (object.default_selection) {
            //   if (type[key] === 'Checkbox') {
            //     if (object.name === 'Not In Display') {
            //       this.notInDisplayId = object.id
            //       this.fixedNotInDisplayId = this.notInDisplayId
            //     }
            //     this.selectedGoalsAndDisplay.push(object.id)
            //   } else if (type[key] === 'RadioButton') {
            //     this.selectedRadioGoalsAndDisplay = object.id
            //   }
            // }
          }
          this.isDefaultChecked = false
        })
      }
      // console.log(this.displayCheckBoxArray)
    },
    close () {
      this.setZonePrice(null)
      if (this.itemRemoved && this.popupType === 'approveWithChanges') {
        this.$router.push(this.landingScreen)
      }
      this.closePopUp(false)
    },
    approveMessages () {
      return this.approveMessage.split('.')
    },
    getTableDataFrom (offersListData) {
      return offersListData.map(offer => {
        return values(offer)
      })
    },
    getOffersListHeaders (offersListSchema) {
      let listHeaders = []
      for (let offer in offersListSchema) {
        listHeaders.push(offersListSchema[offer].name)
      }
      return listHeaders
    },
    getScrollableWidth () {
      try {
        if (
          document.getElementById('selectedOffersInnerDiv') &&
          document.getElementById('selectedOffersHeaderContainer')
        ) {
          let selectedOffersInnerDiv = document.getElementById('selectedOffersInnerDiv').clientWidth
          let selectedOffersHeaderContainer = document.getElementById('selectedOffersHeaderContainer').clientWidth
          let paddingOnInnerDiv = 40
          return `${selectedOffersInnerDiv - selectedOffersHeaderContainer - paddingOnInnerDiv}px`
        }
      } catch (e) {
        return 0
      }
    },
    getScrollableChildrenWidth (n) {
      return `${(100 / n)}%`
    },
    showTimeZone () {
      let result = []
      if (Array.isArray(this.selectedMegaList)) {
        result = [...result, ...this.selectedMegaList]
      } else {
        result.push(this.selectedMegaList)
      }
      if (Array.isArray(this.selectedDisplayList)) {
        result = [...result, ...this.selectedDisplayList]
      } else {
        result.push(this.selectedDisplayList)
      }
      if (Array.isArray(this.selectedGoalList)) {
        result = [...result, ...this.selectedGoalList]
      } else {
        result.push(this.selectedGoalList)
      }
      if (Array.isArray(this.selectedDurationList)) {
        result = [...result, ...this.selectedDurationList]
      } else {
        result.push(this.selectedDurationList)
      }
      if (Array.isArray(this.selectedSignatureList)) {
        result = [...result, ...this.selectedSignatureList]
      }
      if (Array.isArray(this.selectedThemeList)) {
        result = [...result, ...this.selectedThemeList]
      } else {
        result.push(this.selectedThemeList)
        this.disabledApprovedButton = false
        var addTextIdArray = this.goalsAndDisplayCategories[this.THEME]
        var id = find(addTextIdArray, { 'id': this.selectedThemeList, 'name': this.addTextKeyName })
        if (id) {
          if (this.addTextVmodel && this.addTextVmodel.trim().length > 0) {
            this.disabledApprovedButton = false
            result.push({ [this.selectedThemeList]: this.addTextVmodel })
          } else {
            this.pop({
              header: 'ERROR!!',
              message: id.name + ' option cannot be blank for ' + this.THEME + '.',
              type: 'ERROR'
            })
            /* If api must hit though text not added then uncomment out */
            // var index = result.indexOf(this.selectedThemeList)
            // result.splice(index, 1)
            this.disabledApprovedButton = true
          }
        }
      }

      let approveData = {
        offerId: this.gettersSelectedOfferName.id,
        goalsAndDisplayDetails: result
      }
      if (this.approveWithLockUpdated && !this.disabledApprovedButton) {
        this.submitOfferLock(merge(approveData, {
          period: this.approveWithLockUpdated.period,
          data: this.approveWithLockUpdated.data
        }))
      } else {
        /* If api must hit though text not added then uncomment out */
        // if (approveData.goalsAndDisplayDetails.indexOf(this.addTextKeyId) !== -1) {
        //   this.disabledApprovedButton = true
        // } else {
        //   this.disabledApprovedButton = false
        // }
        if (!this.disabledApprovedButton) {
          this.actionApproveOffers(approveData)
        }
      }
    },
    rejectOffer () {
      if (!this.rejectOfferReason || this.rejectOfferReason.trim().length === 0) {
        // console.log('reject offer', this.rejectOfferReason)
        this.pop({
          header: 'Reject Offer',
          message: 'You must give valid reason for your rejection.',
          buttons: {
            accept: {
              text: 'Try Again'
            }
          },
          type: 'ERROR'
        })
      } else {
        this.isConfirmPopUp = true
        this.confirmOverride = {
          code: CODE.REJECT_OFFER
        }
      }
    },
    populateData () {
      for (let data of this.horizontalTableData) {
        if (data) {
          let obj = {}
          for (let i = 0; i < data.length; i++) {
            let index = (data[i]).index - 1
            let zoneObject = data[index]
            obj.zoneItemId = zoneObject.id
            obj[this.horizontalTableHeaders[i].key] = zoneObject.value
          }
          this.zoneUpdatedData.push(obj)
        }
      }
    },
    updateZoneData () {
      if (this.horizontalTableData.length) {
        // console.log('Original Data:', this.horizontalTableData)
        let msg = ['Values must meet the following:-', '1. Should only be numeric.', '2. Can either start by +, - or digits', '3. Can have max two digits before or after decimal point.']
        let noError = true
        if (Object.keys(this.changedObjects).length > 0) {
          for (let obj in this.changedObjects) {
            let key = obj
            let value = this.changedObjects[key]
            if (this.validateInputField(value)) {
              noError = false
              let arr = key.split(',')
              let row = Number(arr[0])
              let col = Number(arr[1])
              msg.push(`${this.horizontalTableHeaders[col].value} value is not satisfied the validation requirements at row ${row + 1}`)
              this.pop({
                header: 'Validation Failed!',
                message: msg,
                type: 'ERROR'
              })
            }
          }
          if (noError) {
            this.changedObjects = {}
            this.populateData()
            this.isConfirmPopUp = true
            this.confirmOverride = {
              code: CODE.SET_ZONE
            }
          }
        } else {
          this.populateData()
          this.isConfirmPopUp = true
          this.confirmOverride = {
            code: CODE.SET_ZONE
          }
        }
      }
    },
    horizontalTableEvent (originalZonePriceData, changedValue, row, col) {
      originalZonePriceData[row][col].value = changedValue
      let key = row + ',' + col
      this.changedObjects[key] = changedValue
    },
    approveWithChangesResponse (data) {
      if (typeof data === 'object' && data.hasOwnProperty('goHome')) {
        this.closePopUp(data)
      } else {
        this.setZonePrice(data)
      }
    },
    confirmEventApproveWithChanges (data) {
      if (data) {
        this.approveWithLockUpdated = data.submit
        this.confirmOverride = data.preview
        this.isConfirmPopUp = true
      }
    },
    validateInputField (value) {
      let regex = new RegExp(/^([+-])?\d{1,2}(\.\d{1,2})?$/)
      if (!regex.test(value)) {
        return true
      } else {
        return false
      }
    }
  },
  // beforeCreate () {
  //   this.$options.components.ApproveWithChanges = require('./ApproveWithChanges.vue')
  // },
  created () {
    this.selectedGoalsAndDisplay = []
    window.eventBus.$on('acceptConfirm', (data) => {
      this.popupType = ''
      if (data.code === 'setZone') {
        this.updateZonePrice({ data: this.zoneUpdatedData, original: this.originalZonePrice })
      } else if (data.code === 'rejectOffer' && this.rejectOfferReason) {
        this.actionRejectOffer({ offerId: this.gettersSelectedOfferName.id, reason: this.rejectOfferReason })
      } else if (data && data.code === 'approveWithChanges') {
        // this.submitOfferLock(this.approveWithLockUpdated)
        let offerObject = this.gettersSelectedOfferName
        if (offerObject && offerObject.id) {
          this.disabledApprovedButton = false
          this.actionGetGoalsAndDisplay({offerId: offerObject.id})
        } else {
          this.disabledApprovedButton = false
          this.actionGetGoalsAndDisplay()
        }
        this.selectedMegaList = []
        this.selectedDisplayList = []
        this.selectedGoalList = []
        this.selectedSignatureList = []
        this.popupType = 'goalsAndDisplayType'
        this.isConfirmPopUp = false
        this.showZonePrice = false
        this.isDefaultChecked = true
      }
    })
    window.eventBus.$on('cancelConfirm', (data) => {
      this.isConfirmPopUp = false
    })
    this.offersListData = this.getTableDataFrom(mockSelectedOffers.data)
    this.offersListHeaders = this.getOffersListHeaders(selectedOffersSchema)
  },
  beforeDestroy () {
    window.eventBus.$off('acceptConfirm')
    window.eventBus.$off('cancelConfirm')
  },
  components: {
    DataTable,
    HorizontalTable,
    ConfirmationPopUp,
    ApproveWithChanges
  }
}
</script>

<style scoped>
  .scrollable {
    overflow: scroll;
    max-height: 280px;
  }

  .header {
    height: 5rem;
    display: inline-block;
    padding: 1rem;
    background-color: #009933
  }

  .bottom {
    bottom: 0;
    position: absolute;
    margin-bottom: 1.5rem;
  }

  .checkbox {
    padding: 0.5rem;
    font-size: 1.3rem;
  }

  .inline-block {
    /*padding: 1.5rem;*/
    display: inline-block;
    vertical-align: top;
  }

  .full_width {
    width: 100%;
  }

  .close {
    position: absolute;
    top: 0;
    right: 1.1rem;
    font-size: 2.8rem;
    cursor: pointer;
    color: black;
  }

  .overlay {
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0, 0.3);
    overflow: hidden;
  }

  .overlay span:hover, .overlay span:focus {
    color: #ccc
  }

  dd {
    margin-left: 0
  }

  dd div field {
   margin-right:1rem;
  }

  .hover-detail {
    /*position: absolute;*/
    width: 160px;
    height: 40px;
    margin: 0.5rem 1rem;
    padding: 0.5rem 0.5rem;
    background: white;
    border-radius: .3rem;
    border: .1rem solid rgb(16,140,137);
    opacity: 1;
    z-index: 100;
    transition: opacity .5s ease-out;
  }

 .field {
   padding: 1rem;
   margin-left: 1rem;
   margin-right: 1rem;
  }

  .text {
    font-size: 1.8rem;
    color: black;
  }

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  ul li {
    padding: 1rem;
    font-size: 1.8rem;
  }

  @media only screen and (max-width: 1000px) {
    .pop-up-container {
      top: 25%;
    }
  }

  @media only screen and (max-width: 900px) {
    .pop-up-container {
      top: 25%;
      left: 2%;
      right: 2%
    }
  }

  .slide-enter {
    transform: translateX(-15%);
    opacity: 0;
  }

  .slide-enter-active {
    animation: slide-in 1s ease-out forwards;
    transition: opacity 0.5s;
  }

  .slide-leave {
    opacity: 1
  }

  .slide-leave-active {
    animation: slide-out 1s ease-out forwards;
    transition: opacity 1s;
    opacity: 0;
  }

  .fade-enter {
    opacity: 0;
  }

  .fade-enter-active {
    transition: opacity 0.5s;
  }

  .fade-leave {
    opacity: 1
  }

  .fade-leave-active {
    transition: opacity 0.5s;
    opacity: 0;
  }

  @keyframes slide-in {
    from {
      transform: translateY(100%);
    }
    to {
      transform: translateY(0px);
    }
  }
  @keyframes slide-out {
    from {
      transform: translateY(0px);
    }
    to {
      transform: translateY(100%);
    }
  }

</style>



// WEBPACK FOOTER //
// Main.vue?45a38fe8